import { render, staticRenderFns } from "./vabOnlyOffice.vue?vue&type=template&id=051d9df3"
import script from "./vabOnlyOffice.vue?vue&type=script&lang=js"
export * from "./vabOnlyOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports